import * as tslib_1 from "tslib";
import closeCompose from './closeCompose';
import composeStore from '../store/composeStore';
import discardCompose from './discardCompose';
import setIsSavingSpinnerShown from './setIsSavingSpinnerShown';
import trySaveMessage, { waitForActiveSaving } from './trySaveMessage';
import { action, select } from 'satcheljs/lib/legacy';
import { isViewStateDirty } from '../utils/viewStateUtils';
import blockOnNavigation from '../utils/blockOnNavigation';
export default action('trySaveAndCloseCompose')(select({
    defaultViewState: function () { return composeStore.defaultViewState; },
})(function trySaveAndCloseCompose(viewState, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!viewState) {
                        viewState = state.defaultViewState;
                    }
                    if (!viewState) return [3 /*break*/, 3];
                    return [4 /*yield*/, blockOnNavigation(viewState)];
                case 1:
                    if (_a.sent()) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, waitForActiveSaving(viewState)];
                case 2:
                    _a.sent();
                    if (isViewStateDirty(viewState)) {
                        setIsSavingSpinnerShown(viewState, true /*isShown*/);
                        return [2 /*return*/, trySaveMessage(viewState, false /*isAutoSave*/, true /*rejectWhenFail*/)
                                .then(function () {
                                setIsSavingSpinnerShown(viewState, false /*isShown*/);
                                closeCompose(viewState);
                            })
                                .catch(function () {
                                setIsSavingSpinnerShown(viewState, false /*isShown*/);
                            })];
                    }
                    else if (viewState.itemId &&
                        viewState.operation != 4 /* EditDraft */ &&
                        !viewState.lastSaveTimeStamp) {
                        // item has upgraded (has itemId but doesn't have lastSaveTimeStamp) but item is not dirty in R/RA/F scenario, we should delete the draft
                        discardCompose(viewState);
                    }
                    else {
                        closeCompose(viewState);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/, Promise.resolve()];
            }
        });
    });
}));
//# sourceMappingURL=trySaveAndCloseCompose.js.map